import { Link } from "react-router-dom";
import { channels, articles } from "@/mocks/news";

export default function ChannelNav() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-12" aria-labelledby="channel-heading">
      <div className="mb-6 border-b border-background-200 pb-4">
        <h2 id="channel-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
          主题分类
        </h2>
        <p className="mt-2 font-body text-sm leading-6 text-foreground-600">
          按频道浏览爆料内容，每个频道都有独立的更新节奏与内容侧重点。
        </p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {channels.map((channel) => {
          const count = articles.filter((item) => item.channelSlug === channel.slug).length;
          return (
            <Link
              key={channel.slug}
              to={`/channel/${channel.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${channel.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">{channel.name}</span>
                  <span className="font-label text-xs text-secondary-500">{count} 篇</span>
                </span>
                <span className="mt-1.5 block font-body text-sm leading-6 text-foreground-600">
                  {channel.description}
                </span>
                <span className="mt-3 flex items-center gap-1 font-label text-xs text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  进入频道
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}